import { render, staticRenderFns } from "./BalanceChangeList.vue?vue&type=template&id=ff7464b4&scoped=true"
import script from "./BalanceChangeList.vue?vue&type=script&lang=js"
export * from "./BalanceChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7464b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7464b4')) {
      api.createRecord('ff7464b4', component.options)
    } else {
      api.reload('ff7464b4', component.options)
    }
    module.hot.accept("./BalanceChangeList.vue?vue&type=template&id=ff7464b4&scoped=true", function () {
      api.rerender('ff7464b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user/BalanceChangeList.vue"
export default component.exports